/* PopUpDisplayRenderer.js */

"use strict";

const _ = require('lodash');
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.ComboBox;
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;
const PopUpPrefsDisplayComponent = require("../pop_up_prefs/PopUpDisplayComponent");

class PopUpDisplayRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("pop-up-display");
        this._rootElem.component = this._model;
        this._rootElem.tabIndex = -1;

        this._arrowUp = document.createElement('div');
        this._arrowUp.classList.add('arrow');
        this._userContentContainer = document.createElement('div');
        this._userContentContainer.classList.add('user-content-container');
        this._avatarContainer = document.createElement('div');
        this._avatarContainer.classList.add('avatar-container');
        this._userInfoContainer = document.createElement('div');
        this._userInfoContainer.classList.add('user-info-container');
        this._buttonContainer = document.createElement('div');
        this._buttonContainer.classList.add('button-container');
        
        this._avatarIcon = document.createElement('base-icon-gl');
        this._avatarIcon.dataset.dark = true;
        this._avatarIcon.dataset.icon = 'common.avatar';
        this._avInitialsEl = document.createElement("p");
        this._avInitialsEl.classList.add("hidden");

        this._profImage = document.createElement("img");
        this._profImage.classList.add("hidden");

        this._name = document.createElement('div');
        this._name.classList.add('name');
        // this._name.setAttribute('title',"Username");

        this._role = document.createElement('div');
        this._role.classList.add('role');
        this._role.setAttribute('title',"Role");

        this._email = document.createElement('div');
        this._email.classList.add('email');
        this._email.setAttribute('title',"Email Address");

        this._userId = document.createElement('div');
        this._userId.classList.add('userId');
        this._userId.setAttribute('title',"User Name");

        this._organizationDropdown = new ComboBoxControl({
            placeholder: 'Organizations',
            darkTheme: true
        });

        this._projectDropdown = new ComboBoxControl({
            placeholder: 'Projects',
            darkTheme: true
        });
        //defaults to hidden
        this._projectDropdown.hide();
        

        this._menuButton = new ButtonControl({
            darkTheme: true,
            label: 'Edit my profile',
            class: "text-button"
        });
        this._preferences = new ButtonControl({
            darkTheme: true,
            label: 'Preferences',
            class: "text-button"
        });
        this._logoutButton = new ButtonControl({
            active: true,
            label: 'Sign out',
            class: "text-button"
        });

        this._popupPrefsDisplay = new PopUpPrefsDisplayComponent({ context: this._model._homeBarContext });

        this._popUpWidget = new PopUpWidget({
            content: this._popupPrefsDisplay.renderer.rootElement,
            anchor: this._preferences.renderer.rootElement,
            anchorPoint: "topLeft",
            displayDirection: "topLeft",
            parent: this._rootElem,
            openOnHover: true
            // confirmPopupFunc: this._onConfirmSolutionSwitchPopup = this._onConfirmSolutionSwitchPopup.bind(this)
        });


        this._avatarContainer.appendChild(this._avatarIcon);
        this._userInfoContainer.appendChild(this._name);
        this._avatarContainer.appendChild(this._avInitialsEl);
        this._avatarContainer.appendChild(this._profImage);
        this._userInfoContainer.appendChild(this._role);
        this._userInfoContainer.appendChild(this._userId);
        this._userInfoContainer.appendChild(this._projectDropdown.renderer.rootElement);
        this._projectDropdown.renderer.rootElement.setAttribute('title',"Projects");
        //this._userInfoContainer.appendChild(this._organizationDropdown.renderer.rootElement);
        //this._organizationDropdown.renderer.rootElement.setAttribute('title',"Organizations");
        this._userContentContainer.appendChild(this._avatarContainer);
        this._userContentContainer.appendChild(this._userInfoContainer);
        //this._buttonContainer.appendChild(this._helpButton.renderer.rootElement);
        this._buttonContainer.appendChild(this._menuButton.renderer.rootElement);
        this._buttonContainer.appendChild(this._preferences.renderer.rootElement);
        this._buttonContainer.appendChild(this._logoutButton.renderer.rootElement);
        this._rootElem.appendChild(this._arrowUp);
        this._rootElem.appendChild(this._userContentContainer);
        this._rootElem.appendChild(this._buttonContainer);

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;

            resolve();
        });
        return prom;
    }
    _registerListeners(){
        this._model.addListener("Name",this._onName = this._onName.bind(this));
        this._model.addListener("Email",this._onEmail = this._onEmail.bind(this));
        this._model.addListener("Role", this._onRole = this._onRole.bind(this));
        this._model.addListener("UserId", this._onUserId = this._onUserId.bind(this));
        this._model.addListener("ProfileImage", this._onProfileImage = this._onProfileImage.bind(this));
        this._model.addListener("Organizations",this._onOrganizations = this._onOrganizations.bind(this));
        this._model.addListener("OrganizationsDisabled",this._onOrganizationsDisabled = this._onOrganizationsDisabled.bind(this));
        this._model.addListener("Projects",this._onProjects = this._onProjects.bind(this));
        this._model.addListener("ProjectsDisabled",this._onProjectsDisabled = this._onProjectsDisabled.bind(this));
        this._model.addListener("MenuDisabled",this._onMenuDisabled = this._onMenuDisabled.bind(this));
        this._model.addListener("ActiveOrganization",this._onActiveOrganization = this._onActiveOrganization.bind(this));
        this._model.addListener("ActiveProject",this._onActiveProject = this._onActiveProject.bind(this));
        this._model.addListener("Shown",this._onShown = this._onShown.bind(this));
        this._model.addListener("Focus",this._onFocus = this._onFocus.bind(this));
        this._model.addListener("Blur",this._onBlur = this._onBlur.bind(this));
        this._projectDropdown.addListener('UserValue', this._onProjectDropdownUserChange = this._onProjectDropdownUserChange.bind(this));
        this._menuButton.addListener('UserClick', this._onMenuButtonUserClick = this._onMenuButtonUserClick.bind(this));
        this._logoutButton.addListener('UserClick', this._onLogoutButtonUserClick = this._onLogoutButtonUserClick.bind(this));
        
        this._rootElem.addEventListener('focus', this._onFocusEvent = this._onFocusEvent.bind(this));
        this._rootElem.addEventListener('blur', this._onBlurEvent = this._onBlurEvent.bind(this));

        this._menuButton.getRenderer().getRootElement().addEventListener('mouseover', this._onMouseOverOtherLinks = this._onMouseOverOtherLinks.bind(this));
        this._logoutButton.getRenderer().getRootElement().addEventListener('mouseover', this._onMouseOverOtherLinks = this._onMouseOverOtherLinks.bind(this));
        this._preferences.getRenderer().getRootElement().addEventListener('mouseover', this._onMouseOverPreferences = this._onMouseOverPreferences.bind(this));
    }
    _unregisterListeners(){
        this._model.removeListener("Name",this._onName);
        this._model.removeListener("Email",this._onEmail);
        this._model.removeListener("Role", this._onRole);
        this._model.removeListener("UserId", this._onUserId);
        this._model.removeListener("ProfileImage", this._onProfileImage);
        this._model.removeListener("Organizations",this._onOrganizations);
        this._model.removeListener("OrganizationsDisabled",this._onOrganizationsDisabled);
        this._model.removeListener("Projects",this._onProjects);
        this._model.removeListener("ProjectsDisabled",this._onProjectsDisabled);
        this._model.removeListener("MenuDisabled",this._onMenuDisabled);
        this._model.removeListener("ActiveOrganization",this._onActiveOrganization);
        this._model.removeListener("ActiveProject",this._onActiveProject);
        this._model.removeListener("Disabled",this._onDisabled);
        this._model.removeListener("Shown",this._onShown);
        this._model.removeListener("Focus",this._onFocus);
        this._model.removeListener("Blur",this._onBlur);
        this._projectDropdown.removeListener('UserValue', this._onProjectDropdownUserChange);
        this._projectDropdown.removeListener('UserValue', this._onProjectDropdownUserChange);
        this._menuButton.removeListener('UserClick', this._onMenuButtonUserClick);
        this._logoutButton.removeListener('UserClick', this._onLogoutButtonUserClick);
        this._rootElem.removeEventListener('focus', this._onFocusEvent);
        this._rootElem.removeEventListener('blur', this._onBlurEvent);

        this._menuButton.getRenderer().getRootElement().removeEventListener('mouseover', this._onMouseOverOtherLinks);
        this._logoutButton.getRenderer().getRootElement().removeEventListener('mouseover', this._onMouseOverOtherLinks);
        this._preferences.getRenderer().getRootElement().removeEventListener('mouseover', this._onMouseOverPreferences);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        let prom = new Promise((resolve/*,reject*/) => {
            this._setName(this._model.getName(), this._model.getNameArray());
            this._setRole(this._model.getRole());
            this._setEmail(this._model.getEmail());
            this._setProfileImage(this._model.getProfileImage());
            //this._setOrganizations(this._model.getOrganizations());
            //this._setActiveOrganization(this._model.getActiveOrganization());
            this._setProjects(this._model.getProjects());
            this._setActiveProject(this._model.getActiveProject());
            this._setShown(this._model.getShown());
            resolve();
        });
        return prom;
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onProfileImage(newVal) {
        this._setProfileImage(newVal);
    }
    /**
     * Fired when the user's name has been updated in the model
     * @param newVal {object}
     * @private
     */
    _onName(newVal, arr){
        this._setName(newVal, arr);
    }

    _onRole(newVal) {
        this._setRole(newVal);
    }

    _onUserId(newVal) {
        this._setUserId(newVal);
    }

    /**
     * Fired when the user's email address has been updated in the model
     * @param newVal {array}
     * @private
     */
    _onEmail(newVal){
        this._setEmail(newVal);
    }

    /**
     * Fired when the organizations have been updated in the model
     * @param newVal {object}
     * @private
     */
    _onOrganizations(newVal){
        this._setOrganizations(newVal);
    }
    _onProjects(newVal){
        this._setProjects(newVal);
    }

    /**
     * Fired when the organizations have been disabled/enabled
     * @param newVal {boolean}
     * @private
     */
    _onOrganizationsDisabled(newVal){
        this._setOrganizationsDisabled(newVal);
    }
    _onProjectsDisabled(newVal){
        this._setProjectsDisabled(newVal);
    }

    /**
     * Fired when the menu has been disabled/enabled
     * @param newVal {boolean}
     * @private
     */
    _onMenuDisabled(newVal){
        this._setMenuDisabled(newVal);
    }

    /**
     * Fired when the active organization have been updated in the model
     * @param newVal {object}
     * @private
     */
    _onActiveOrganization(newVal){
        this._setActiveOrganization(newVal);
    }
    _onActiveProject(newVal){
        this._setActiveProject(newVal);
    }

    /**
     * Fired when shown state has been toggled in the model
     * @param newVal {boolean}
     * @private
     */
    _onShown(newVal){
        this._setShown(newVal);
    }

    /**
     * Fired when the user has selected a new org from the org dropdown
     * @param newVal {object|array|boolean|number|string}
     * @param oldVal {object|array|boolean|number|string}
     * @param event {event}
     * @private
     */
    _onOrganizationDropdownUserChange(newVal, oldVal, event){
        this._model._triggerOrganizationChange(newVal, oldVal, event);
    }

    _onProjectDropdownUserChange(newVal, oldVal, event){
        this._model._triggerProjectChange(newVal, oldVal, event);
    }

    /**
     * Fired when the user has clicked the menu button
     * @param event {event}
     * @private
     */
    _onMenuButtonUserClick(event){
        this._model._triggerMenuSelected(event);
    }

    /**
     * Fired when the user has clicked the log out button
     * @param event {event}
     * @private
     */
    _onLogoutButtonUserClick(event){
        this._model._triggerLogOutSelected(event);
    }

    /**
     * Fired when focus has been called in the model
     * @private
     */
    _onFocus(){
        this._setFocus(true);
    }

    /**
     * Fired when blur has been called in the model
     * @private
     */
    _onBlur(){
        this._setFocus(false);
    }

    /**
     * Pass the focus event up to the model
     * @param event {Event}
     * @private
     */
    _onFocusEvent(/*event*/){
        //this._model._triggerUserFocus(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onBlurEvent(/*event*/){
        //this._model._triggerUserBlur(event);
    }


    _onMouseOverOtherLinks(e) {
        e.preventDefault();

        this._popupPrefsDisplay.emit("SomethingElseHovered");
    }

    _onMouseOverPreferences(e) {
        e.preventDefault();
        this._popupPrefsDisplay.emit("PreferencesHovered");
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _setProfileImage(src) {
        if(!src) {
            return;
        }
        this._profImage.src = src;
        this._profImage.classList.remove("hidden");
        this._avatarIcon.classList.add("hidden");
        this._avInitialsEl.classList.add("hidden");
    }
    /**
     * Update the user's name
     * @param newVal {string}
     * @private
     */
    _setName(newVal, arr){
        this._name.innerHTML = newVal;
        this._setInitials(arr);
        this._avInitialsEl.classList.remove("hidden");
        this._avatarIcon.classList.add("hidden");
        this._profImage.classList.add("hidden");
    }

    _setRole(newVal) {
        this._role.innerHTML = newVal;
    }

    _setUserId(newVal) {
        this._userId.innerHTML = newVal;
    }

    _setInitials(nameArr) {
        const fInitial = nameArr[0] ? nameArr[0].charAt(0).toUpperCase(): "";
        const lInitial = nameArr[1] ? nameArr[1].charAt(0).toUpperCase():"";
        this._avInitialsEl.innerHTML = fInitial + lInitial;
        this._setBackground(fInitial, lInitial);
    }

    _setBackground(fInitial, lInitial) {
        let fCode = 0, lCode = 0;
        if(fInitial) {
            fCode = fInitial.charCodeAt(0);
        }
        if(lInitial) {
            lCode = lInitial.charCodeAt(0);
        }

        const bgNum = ((fCode + lCode) % 14) + 1;
        this._avInitialsEl.classList.add("bg-color-grp-"+bgNum);
    }

    /**
     * Update the user's email
     * @param newVal {string}
     * @private
     */
    _setEmail(newVal){
        this._email.innerHTML = newVal;
    }

    /**
     * Update the organizations
     * @param newVal {array}
     * @private
     */
    _setOrganizations(newVal){
        this._organizationDropdown.setOptions(newVal);
    }

    _setProjects(newVal){
        if(newVal && !_.isEmpty(newVal)){
            this._projectDropdown.show();
        }
        else{
            this._projectDropdown.hide();
        }
        this._projectDropdown.setOptions(newVal);
    }

    /**
     * Disable/enable the organizations dropdown
     * @param newVal {boolean}
     * @private
     */
    _setOrganizationsDisabled(newVal){
        this._organizationDropdown.setDisabled(newVal);
    }
    _setProjectsDisabled(newVal){
        this._projectDropdown.setDisabled(newVal);
    }

    /**
     * Disable/enable the menu button
     * @param newVal {boolean}
     * @private
     */
    _setMenuDisabled(newVal){
        this._menuButton.setDisabled(newVal);
    }

    /**
     * Update the active organization
     * @param newVal {object}
     * @private
     */
    _setActiveOrganization(newVal){
        this._organizationDropdown.setValue(newVal);
    }
    _setActiveProject(newVal){
        this._projectDropdown.setValue(newVal);
    }

    /**
     * Toggle the shown state
     * @param newVal {boolean}
     * @private
     */
    _setShown(newVal){
        if (newVal === true) {
            this._rootElem.classList.add('shown');
        } else {
            this._rootElem.classList.remove('shown');
        }
    }

    /**
     * Set or remove focus
     * @param newVal {boolean}
     * @private
     */
    _setFocus(newVal){
        if (newVal === true) {
            this._rootElem.focus();
        } else {
            this._rootElem.blur();
        }
    }


    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PopUpDisplayRenderer;